import * as pushStyles from '../../styles/actualites/push-event.module.scss';
import PropTypes from 'prop-types';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import IconContainer from '../shared/IconContainer';
import {Link} from 'gatsby';
import React from 'react';
import clsx from 'clsx';
import {faCircle} from '@fortawesome/free-solid-svg-icons';
import {getDisplayLang} from '../../utils/parsing';
import {useTranslation} from 'react-i18next';

const PushEvent = ({
  preview, date, href, title, live, eventLanguage, locale, objectID,
}) => {
  const displayLang = getDisplayLang(eventLanguage, locale);
  const dateTimeLang = locale === 'en' ? 'en-EN' : 'fr-FR';
  const day = new Date(date).toLocaleString(dateTimeLang, {weekday: 'short', timeZone:'CET'});
  const dayNumber = new Date(date).getDate();
  const month = new Date(date).toLocaleString(dateTimeLang, {month: 'long', timeZone:'CET'});
  const year = new Date(date).toLocaleString(dateTimeLang, {year: 'numeric', timeZone:'CET'});
  const {t} = useTranslation();

  const getTitle = () => {
    if (displayLang) {
      return (
        <h3 className={pushStyles.title}
          lang={displayLang}
        >
          {title}
        </h3>
      );
    }
    return <h3 className={pushStyles.title}>{title}</h3>;
  };

  const getHeading = () => {
    if (displayLang) {
      return (
        <p className={pushStyles.preview}
          lang={displayLang}
        >
          {preview}
        </p>
      );
    }
    return <p className={pushStyles.preview}>{preview}</p>;
  };

  return (
    <Link
      className={pushStyles.linkRoot}
      key={objectID}
      to={href}
    >
      <div className={pushStyles.rootSmartphone}>
        <div className={pushStyles.smartphoneDateBloc}>
          <div className={pushStyles.containerButton}>
            <div className={pushStyles.smartphoneNumberBloc}>
              <p className={pushStyles.dayNumber}>{dayNumber}</p>
            </div>
            <div className={pushStyles.smartphoneDayBloc}>
              <p className={pushStyles.day}>{day}</p>
            </div>
          </div>
          <div className={pushStyles.smartphoneMonthBloc}>
            <div className={pushStyles.smartphoneSeparation}></div>
            <p className={pushStyles.month}>
              {month} {year}
            </p>
          </div>
        </div>
        <div className={pushStyles.smartphoneDescriptionBloc}>
          <div className={pushStyles.smartphoneTitleBloc}>{getTitle()}</div>
          <div className={pushStyles.smartphonePreviewBloc}>
            {getHeading()}
          </div>
          <div className={pushStyles.linkBloc}>
            <div
              className={pushStyles.more}
              style={{display: 'flex', alignItems: 'center'}}
            >
              <p className={pushStyles.more}>
                {t('event.guide.page.more.url')}
              </p>
              <div style={{marginLeft: 8}}>
                <IconContainer
                  classname={pushStyles.more}
                  color="BLACK"
                  icon="ARROW_RIGHT_NORMAL"
                  size={20}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={pushStyles.rootDesktop}>
        <div className={pushStyles.dateBloc}>
          <div className={pushStyles.monthBloc}>
            <p className={pushStyles.month}>
              {month} {year}
            </p>
          </div>
          <div className={pushStyles.separation}></div>
          <div className={pushStyles.numberBloc}>
            <p className={pushStyles.dayNumber}>{dayNumber}</p>
            <p className={pushStyles.day}>{day}</p>
          </div>
        </div>
        <div
          className={clsx(pushStyles.descriptionBloc, pushStyles.height)}
          style={{width: '75%'}}
        >
          <div className={pushStyles.typeBloc}>
            {live && (
              <div
                className={pushStyles.liveButton}
                lang={locale === 'fr' ? 'en' : ''}
              >
                <FontAwesomeIcon
                  aria-hidden="true"
                  focusable="false"
                  icon={faCircle}
                  size="xs"
                  style={{marginRight: 5}}
                >
                </FontAwesomeIcon>
                <p className={pushStyles.stringLive}>LIVE</p>
              </div>
            )}
          </div>
          <div className={pushStyles.titleBloc}>{getTitle()}</div>
          <div className={pushStyles.previewBloc}>{getHeading()}</div>
          <div className={pushStyles.linkBloc}>
            <div style={{display: 'flex', alignItems: 'center'}}>
              <p className={pushStyles.more}>
                {t('event.guide.page.more.url')}
              </p>
              <div style={{marginLeft: 8}}>
                <IconContainer
                  classname={pushStyles.more}
                  color="BLACK"
                  icon="ARROW_RIGHT_NORMAL"
                  size={20}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>);
};

PushEvent.propTypes = {
  date: PropTypes.string.isRequired,
  eventLanguage: PropTypes.string,
  href: PropTypes.string.isRequired,
  live: PropTypes.bool,
  locale: PropTypes.string.isRequired,
  objectID: PropTypes.string.isRequired,
  preview: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export default PushEvent;
